module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p4"
  }, [_vm._v("Mi sincera gratitud a:")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Amy y Carol,")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("por su incansable guía.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Troy, por ayudarme a trabajar")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("esas 11.000 palabras finales.")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("Mi marido Sean,")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("por apoyarme de todas las maneras")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("posibles con su mayor empeño,")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("incluso cuando le prestaba")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_vm._v("más atención a Angelo que a él.")]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0debf748","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/004.vue
// module id = 63
// module chunks = 0